import { useEffect, useState } from "react";

import "./MultiselectUnsubscribe.css";
import { getMultiselectLabels } from "../api/requests";
import { UnsubsribeFormLabels } from "../labels/UnsubsribeFormLabels";
import QueryParameters from "../api/QueryParameters";
import { UnsubscribeFormLabelsMapper } from "../mappers/labels/UnsubscribeFormLabelsMapper";
import { ConsentsLabelMapper } from "../mappers/ConsentsLabelMapper";
import Spinner from "../components/Spinner";
import OptOutButton from "../components/OptOutButton";
import ErrorMessage from "../components/ErrorMessage";
import UnsubscribeLink from "../components/UnsubscribeLink";
import { ConsentsOption, Consent } from "../common/GeneralClasses";

export default function MultiselectUnsubscribe() {
  const [labels, setLabels] = useState<UnsubsribeFormLabels>({} as UnsubsribeFormLabels);
  const [options, setOptions] = useState<ConsentsOption[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [optOutState, setOptOutState] = useState([] as Consent[]);

  useEffect(() => {
    setLoading(true);
    const queryParams = new QueryParameters();
    getMultiselectLabels(queryParams).then((data) => {
      const formLabelMapper = new UnsubscribeFormLabelsMapper();
      const consentsLabelMapper = new ConsentsLabelMapper();
      setLabels(formLabelMapper.get(data.labels));
      setOptions(consentsLabelMapper.get(data.consentsWithLabel));
      setError(data.error);
      setLoading(false);
    });
  }, []);

  function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    const name = event.target.name;
    const checked = event.target.checked;
    if (checked) {
      //It's opt out. So removing from the array when checkbox is checked
      const newConsents = optOutState.filter((consent) => consent.code !== name);
      setOptOutState(newConsents);
    } else {
      const newConsents = [...optOutState, { code: name, channel: value }];
      setOptOutState(newConsents);
    }
  }

  if (loading) {
    return (
      <div className="center">
        <Spinner isLoading={true} />
      </div>
    );
  }
  return (
    <div className="multiselect-unsubscribe">
      <h1>{labels.title.value}</h1>
      <div className="divider"></div>
      {error ? <ErrorMessage errorMessage={labels.error.value} /> : ""}
      <p dangerouslySetInnerHTML={{ __html: labels.subtitle.value }} />

      {options.map((option) => (
        <div key={option.id}>
          <label className="checkbox-label" htmlFor={option.id}>
            <input
              type="checkbox"
              id={option.id}
              name={option.id}
              value={option.channel}
              onChange={handleCheckboxChange}
              defaultChecked={true}
            />
            {option.checkboxLabel}
          </label>
        </div>
      ))}

      <p dangerouslySetInnerHTML={{ __html: labels.footer.value }} />
      <p dangerouslySetInnerHTML={{ __html: labels.policyLinks.value }} />

      <UnsubscribeLink
        thankYouLabel={labels.thankYouBulkUnsubscribe.value}
        errorMessage={labels.error.value}
        confirmButtonLabel={labels.confirmButtonLabel.value}
      />
      <OptOutButton
        buttonLabel={labels.button.value}
        thankYouLabel={labels.thankYou.value}
        errorMessage={labels.error.value}
        optOutState={optOutState}
        confirmButtonLabel={labels.confirmButtonLabel.value}
        confirmButtonUrl={labels.brandHomepageUrl.value}
      />
    </div>
  );
}
